import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useHousehold } from "@/context/HouseholdContext";
import { listCandidates, listObligations, listSuggestions, obligationCounts, partitionCandidates } from "@/lib/obligationsApi";

export default function HomeStrip() {
  const { hid } = useHousehold();
  const navigate = useNavigate();
  const [counts, setCounts] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (!hid) return undefined;

    Promise.all([listObligations(hid), listSuggestions(hid), listCandidates(hid, { lane: "all" })])
      .then(([desk, suggestions, candidates]) => {
        if (cancelled) return;
        const { desk: deskCandidates, quarantine } = partitionCandidates(candidates);
        // Feeder candidates are review work too — the strip must agree with
        // the desk header's "to ratify" arithmetic, not undercount it.
        const review = [...suggestions, ...deskCandidates, ...quarantine, ...(desk.captureReview || [])];
        setCounts(obligationCounts(desk.obligations, review));
      })
      .catch(() => {
        if (!cancelled) setCounts({ needs_you: 0, waiting_on_them: 0, gated: 0, to_confirm: 0 });
      });

    return () => {
      cancelled = true;
    };
  }, [hid]);

  if (!counts) return null;
  if (counts.needs_you === 0 && counts.waiting_on_them === 0 && counts.to_confirm === 0) return null;

  return (
    <button
      type="button"
      data-testid="home-obligations-strip"
      onClick={() => navigate("/obligations")}
      className="w-full rounded-[1rem] border border-[hsl(var(--border))] bg-card px-5 py-4 text-left transition-colors hover:bg-[hsl(var(--secondary))]"
    >
      <p className="font-serif text-[1rem] text-[hsl(var(--foreground))]">
        {counts.needs_you} need you · {counts.waiting_on_them} waiting · {counts.to_confirm} to confirm
      </p>
      <p className="mt-1 text-sm text-[hsl(var(--muted-foreground))]">Interrupt-worthy now, if anything truly needs your hand.</p>
    </button>
  );
}
